/* eslint-disable @typescript-eslint/ban-ts-comment */
import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import { env } from '@/lib/env';
import Cookies from 'js-cookie';
import { interceptConfig } from '@/lib/client/config';
import { authAPI } from '@/services/sso';

const baseURL = env.NEXT_PUBLIC_GATEWAY_URL ?? 'https://localhost:8003';

const privateApi: AxiosInstance = axios.create({
  baseURL: baseURL + '/webstore/v1',
});

export const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers = {
    ...config.headers,
    ...(process.env.NODE_ENV === 'development' ? { 'ngrok-skip-browser-warning': '1' } : {}),
    ...(Cookies.get('accessToken')
      ? { Authorization: `Bearer ${Cookies.get('accessToken')}` }
      : {}),
    ...(Cookies.get('_jstore_sid') ? { 'X-Jstore-Sid': Cookies.get('_jstore_sid') } : {}),
  };

  // Only use for development mode only
  // this is for intercept request api gateway url to Local Dev
  if (process.env.NODE_ENV === 'development') {
    for (const intercept of interceptConfig.intercepts) {
      if (process.env.NODE_ENV === 'development')
        if (config.url?.startsWith(intercept.basepoint) && intercept.enable) {
          config.headers = {
            ...config.headers,
            'X-Jubelio-Intercept-Host': intercept.destinationHost,
            'X-Jubelio-Intercept-Scheme': intercept.destinationScheme,
          };
        }
    }
  }

  return config;
};

export const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

export const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

export const onResponseError = async (error: AxiosError): Promise<AxiosError> => {
  const originalRequest = error.config as InternalAxiosRequestConfig & { _retry?: boolean };
  if (!Cookies.get('accessToken')) {
    window.location.href = env.NEXT_PUBLIC_APP_URL as string;
  }

  if (!Cookies.get('_jstore_sid')) {
    window.location.href = '/switch-store?noRedirect=true';
  }

  if (error.response?.status === 401 && !originalRequest?._retry) {
    try {
      originalRequest._retry = true;
      Cookies.remove('accessToken');
      const result = await authAPI.refreshToken(Cookies.get('refreshToken') as string);
      Cookies.set('accessToken', result.data.accessToken);
      Cookies.set('refreshToken', result.data.refreshToken);
      return privateApi(originalRequest);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(`failed to refresh token`, JSON.stringify(error));
      Cookies.remove('accessToken');
      Cookies.remove('refreshToken');
      Cookies.remove('_partner_id');
      window.location.href = env.NEXT_PUBLIC_APP_URL as string;
    }
  }

  return Promise.reject(error);
};

// @ts-ignore
privateApi.interceptors.request.use(onRequest, onRequestError);
privateApi.interceptors.response.use(onResponse, onResponseError);

export default privateApi;
